import { Component, Input, OnInit } from '@angular/core';
import { EvaluationVehicle } from '@app-model/evaluation';
import { Color, CountryOrigin } from '@app-model/vehicle';

@Component({
  selector: 'app-card-evaluation-info',
  templateUrl: './card-evaluation-info.component.html',
  styleUrls: ['./card-evaluation-info.component.scss']
})
export class CardEvaluationInfoComponent implements OnInit {

  @Input() vehicle: EvaluationVehicle;
  ColorLabel = Color;
  CountryLabel = CountryOrigin;

  isTruck: boolean = false;
  constructor() { }
  ngOnInit(): void {
    this.isTruck = this.vehicle.segment === 'TRUCK';
  }

}
